import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { BadgeColor, BadgeComponent } from '../../shared/components/ui/badge/badge.component';
import { AdminBookingsService } from '../../core/services/admin-bookings.service';
import { AdminBooking } from '../../core/models/admin.models';

interface BookingRow {
  id: number;
  user: string;
  mechanic: string;
  service: string;
  area: string;
  date: string;
  status: string;
  amount: number;
}

@Component({
  selector: 'app-bookings-list',
  standalone: true,
  imports: [CommonModule ,BadgeComponent],
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.css']
})
export class BookingsListComponent implements OnInit {
  bookings: BookingRow[] = [];
  isLoading = false;
  errorMessage = '';

  constructor(
    private router: Router,
    private bookingsService: AdminBookingsService
  ) {}

  ngOnInit(): void {
    this.loadBookings();
  }

  loadBookings(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.bookingsService.getBookings().subscribe({
      next: (res) => {
        const list: AdminBooking[] = Array.isArray(res) ? res : (res as any).data ?? [];
        this.bookings = list.map(b => this.toRow(b));
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load bookings.';
        this.isLoading = false;
      }
    });
  }

  private toRow(b: AdminBooking): BookingRow {
    return {
      id: b.id,
      user: b.user?.name ?? '—',
      mechanic: b.mechanic?.name ?? 'Unassigned',
      service: b.service?.name ?? '—',
      area: b.pickup_address ?? '—',
      date: b.scheduled_at ?? b.created_at,
      status: b.status,
      amount: b.amount
    };
  }

  getBadgeColor(status: string): BadgeColor {
    switch (status.toLowerCase()) {
      case 'pending': return 'warning';
      case 'accepted': 
      case 'enroute': 
      case 'arrived': 
      case 'in_progress': return 'info';
      case 'completed': return 'success';
      case 'cancelled': return 'danger' as BadgeColor;
      default: return 'primary';
    }
  }

  viewBooking(booking: BookingRow) {
    this.router.navigate(['/booking-details', booking.id]);
  }
}

